export default "__VITE_ASSET__Cgpgdebj__"